import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { effects } from './effects';
import { SeoResolversModule } from './resolvers';
import { SeoMetaService } from './services';

@NgModule({
  imports: [EffectsModule.forFeature(effects), SeoResolversModule],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = ((injector: Injector): (() => void) => {
        return () => {
          const service = injector.get(SeoMetaService);
          service.init();
        };
      })(inject(Injector));

      return initializerFn();
    }),
  ],
})
export class SeoFeatureModule {}
